import { pageErrorMessages, resourceErrorMessages } from 'data/error-messages'
import { cn } from 'lib/utils'

export default function ErrorMessage({
    statusCode,
    type = 'page',
    orientation = 'horizontal',
    className,
}) {
    const key = statusCode ?? ''
    const message = type === 'resource' ? resourceErrorMessages[key] : pageErrorMessages[key]

    return (
        <div className='size-full flex-1 flex items-center justify-center'>
            <div
                className={cn('flex items-center gap-6', orientation === 'vertical' && 'flex-col')}
            >
                <span className='font-medium' style={{ fontSize: '2rem' }}>
                    {statusCode}
                </span>
                <span style={{ fontSize: '1.5rem' }}>{message ?? 'Error'}.</span>
            </div>
        </div>
    )
}
